$(function(){
    if ( document.getElementById('mainBooking') ) {
        let bookingDateFormat =  document.getElementById('CheckIn--alt').dataset.format !== '' ? document.getElementById('CheckIn--alt').dataset.format : 'mm/dd/yy';
        let displayDateFormat =  'mm/dd/yy';
        let start, end, op = 0;

        const calendarBeforeShow = date => {
            if ( start !== undefined ){
                let startDate = $.datepicker.parseDate(bookingDateFormat, start);
                let endDate = $.datepicker.parseDate(bookingDateFormat, end);

                if ( date.getTime() == startDate.getTime() ) {
                    return[ true, 'startday' ];
                } else {
                    if ( date.getTime() == endDate.getTime() ) {
                        return[ true, 'endday' ];
                    } else {
                        if( date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime() ){
                            return[ true, 'days' ];
                        } else {
                            return[ true ];
                        }
                    }
                }
            } else{
                return[ true ];
            }
        };

        const calendarOnSelect = date => {
            start = (start !== undefined) ? start : $.datepicker.formatDate(bookingDateFormat, new Date());
            let startDate = $.datepicker.parseDate(bookingDateFormat, start);
            let selectedDate = $.datepicker.parseDate(bookingDateFormat, date);
            
            if ( op === 0 ) {
                op = 1;
                start = date;
                end =  date;  
            } else {
                op = 0;
                if(selectedDate <= startDate){
                    end = start;
                    start = date;  
                } else {
                    end =  date; 
                }
            }

            $('#CheckIn--alt').attr('value',start);
            $('#CheckOut--alt').attr('value',end);

            let startDispaly = $.datepicker.formatDate( displayDateFormat, $.datepicker.parseDate(bookingDateFormat, start) );
            let endDisplay = $.datepicker.formatDate( displayDateFormat, $.datepicker.parseDate(bookingDateFormat, end) );
            $('#CheckInOut').attr('value', `${ startDispaly } - ${ endDisplay }`);
        };

        const calendarOptions = {
            minDate: 0,
            maxDate: '+12M',
            numberOfMonths: 2,
            dateFormat: bookingDateFormat,
            beforeShowDay: calendarBeforeShow,
            onSelect: calendarOnSelect
        };

        $('#dateCalendar').datepicker( calendarOptions );
        $("#CheckInOut").on('keyup', function(){
            const dates = $(this).val().split(' - ');
            $('#CheckIn--alt').val( dates[0] );
            $('#CheckOut--alt').val( dates[1] );
        });
    }
});
